/****************************************************
 * Module Name:  lossProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class LossProxy {
    static GetAllLoss = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/losscategory",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllLossMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/losscategory/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleLoss = (losscategoryid, callback) => {
        let params = {
            id: losscategoryid,
        };

        restAPICall(
            Constants.MANAGER_URL + "/losscategory",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckLossAvailable = (losscategory, callback) => {
        let params = {
            losscategory: losscategory,
        };

        restAPICall(
            Constants.MANAGER_URL + "/losscategory/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddLoss = (shape, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/losscategory",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(shape),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateLoss = (shape, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/losscategory",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(shape),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
